import React, { useEffect } from "react";
// import { Box, Paper } from "@mui/material"; // <-- Больше не нужны здесь
import { Routes, Route } from "react-router-dom";

// Импортируем новый макет
import MainLayout from "./MainLayout"; // <-- Убедись, что путь верный

// Импорт страниц...
import MainPage from "./pages/MainPage";
import Login from "./pages/Login";
import Administration from "./pages/Public/Administration";
import PCK from "./pages/Public/PCK";
import UMR from "./pages/Public/umr";
import News from "./pages/Public/News";
import Photogallery from "./pages/Public/Photogallery";
import Courses from "./pages/Public/Courses";
import Contacts from "./pages/Public/Contacts";
import Abiturient from "./pages/Public/Abiturient";
import AdditionalInfo from "./pages/Public/AdditionalInfo";
import AdminLayout from "./pages/Admin/AdminLayout";
import ProfileTeacher from "./pages/Teacher/ProfileTeacher";
import ProfileStudent from "./pages/Student/ProfileStudent";
// import Header from "./components/pageload/Header"; // <-- Больше не нужны здесь
// import Footer from "./components/pageload/Footer"; // <-- Больше не нужны здесь
import CollegeInfo from "./pages/Public/CollegeInfo";
import Services from "./pages/Public/Services";
import OurAchievements from "./pages/Public/OurAchievements";
import Plan from "./pages/Public/Plan";
import Emcourse from "./pages/Public/Emcourse";
import Resourses from "./pages/Public/Resourses";
import Atistation from "./pages/Public/Atistation";
import AntiCoruption from "./pages/Public/AntiCoruption";
import Gagarin from "./pages/Public/Gagarin";
import RoleAccess from "./RoleAccess";
import useAuthStore from "./services/AuthStore";
import LogoutHandler from "./pages/LogoutHandler";
import NewsDetailPage from "./pages/Public/NewsDetailPage";
import ModLayout from "./pages/Moderator/ModLayout";
import AIZerefullscreen from "./pages/AI/AIZerefullscreen";
import AiChatPage from "./pages/AIChat/AIChatPage";
import Otchet20242025 from "./pages/Public/Otchet20242025";
import Sanitar from "./pages/Public/Sanitar";
import Structure from "./pages/Public/Structure";

export default function App() {
  const { logout } = useAuthStore();

  return (
    <>
      {/* Теперь у нас ОДИН <Routes> блок.
        Логика:
        1. Роуты, которые должны иметь Header/Footer, вложены в <MainLayout />
        2. Роуты, которые НЕ должны, находятся на том же уровне.
      */}
      <Routes>
        {/* === Макет с Header/Footer === */}
        <Route element={<MainLayout />}>
          <Route path="/ai-chat" element={<AiChatPage />} />
          <Route path="/" element={<MainPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/administration" element={<Administration />} />
          <Route path="/pck" element={<PCK />} />
          <Route path="/umr" element={<UMR />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:newsId" element={<NewsDetailPage />} />
          <Route path="/photogallery" element={<Photogallery />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/abiturient" element={<Abiturient />} />
          <Route path="/additionalinfo" element={<AdditionalInfo />} />
          <Route path="/collegeinfo" element={<CollegeInfo />} />
          <Route path="/services" element={<Services />} />
          <Route path="/ourachevements" element={<OurAchievements />} />
          <Route path="/plan" element={<Plan />} />
          <Route path="/emcourse" element={<Emcourse />} />
          <Route path="/emcourse/:docId" element={<Emcourse />} />
          <Route path="/structure" element={<Structure />} />
          <Route path="/resourses" element={<Resourses />} />
          <Route path="/atistation" element={<Atistation />} />
          <Route path="/anticoruption" element={<AntiCoruption />} />
          <Route path="/gagarin" element={<Gagarin />} />
          <Route path="/otchet20242025" element={<Otchet20242025 />} />
          <Route path="/sanitar" element={<Sanitar />} />
          <Route path="/sanitar/*" element={<Sanitar />} />
          <Route path="/sanitary" element={<Sanitar />} />

          {/* Защищенные роуты тоже внутри MainLayout */}
          <Route element={<RoleAccess roles={[1]} />}>
            <Route path="/admin" element={<AdminLayout />} />
          </Route>
          <Route element={<RoleAccess roles={[2]} />}>
            <Route path="/moder" element={<ModLayout />} />
          </Route>
          <Route element={<RoleAccess roles={[3]} />}>
            <Route path="/teacher" element={<ProfileTeacher />} />
          </Route>
          <Route element={<RoleAccess roles={[4]} />}>
            <Route path="/student" element={<ProfileStudent />} />
          </Route>

          <Route path="/logout" element={<LogoutHandler logout={logout} />} />
        </Route>

        {/* === Полноэкранный макет (без Header/Footer) === */}
        <Route path="/aizere-full" element={<AIZerefullscreen />} />

        {/* Сюда можно добавить и другие полноэкранные страницы, например, 404 */}
        {/* <Route path="*" element={<NotFoundPage />} /> */}
      </Routes>
    </>
  );
}
